import { Link } from 'react-router-dom';
import { Facebook, Instagram, Music2, Globe } from 'lucide-react';
import { useLang } from '../i18n';

const Footer = () => {
  const { t } = useLang();
  const nav = [
    { to: '/', label: t('nav.home') },
    { to: '/azienda', label: t('nav.azienda') },
    { to: '/catalogo', label: t('nav.catalogo') },
    { to: '/private-label', label: t('nav.pl') },
    { to: '/contatti', label: t('nav.contatti') },
  ];
  const lines = [
    { to: '/catalogo?cat=kris', label: t('catalogo.kris') },
    { to: '/catalogo?cat=primi', label: t('catalogo.primi') },
    { to: '/catalogo?cat=secondi', label: t('catalogo.secondi') },
  ];
  return (
    <footer className="bg-[#22303C] text-[#F7F5F0] noise-overlay" data-testid="main-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-20 pb-8">
        <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-2">
              <img src="/images/propaq-icon.png" alt="PROPAQ" className="w-9 h-9 rounded-md" />
              <span className="font-display font-extrabold text-xl tracking-tight">PRO<span className="text-secondary">PAQ</span></span>
            </div>
            <p className="font-display text-[10px] uppercase tracking-[0.35em] text-white/40 mb-6">Produzione Alimentare</p>
            <p className="text-white/60 max-w-sm leading-relaxed">{t('footer.tagline')}</p>
            <div className="flex gap-3 mt-8">
              <a href="https://www.facebook.com/profile.php?id=61590313807986" target="_blank" rel="noreferrer" data-testid="footer-facebook-link" className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-secondary hover:border-secondary transition-colors duration-300" aria-label="Facebook">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://www.instagram.com/piattiprontiglutenfree/" target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-secondary hover:border-secondary transition-colors duration-300" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://www.tiktok.com/@piattiprontiglutenfree" target="_blank" rel="noreferrer" data-testid="footer-tiktok-link" className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-secondary hover:border-secondary transition-colors duration-300" aria-label="TikTok">
                <Music2 className="w-4 h-4" />
              </a>
            </div>
          </div>
          <div className="md:col-span-2">
            <h4 className="font-display font-bold text-xs uppercase tracking-[0.2em] text-[#e05560] mb-6">{t('footer.nav')}</h4>
            <ul className="space-y-3">
              {nav.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-white/60 hover:text-white transition-colors duration-300 text-sm" data-testid={`footer-nav-${l.to === '/' ? 'home' : l.to.slice(1)}-link`}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <h4 className="font-display font-bold text-xs uppercase tracking-[0.2em] text-[#e05560] mb-6">{t('footer.lines')}</h4>
            <ul className="space-y-3">
              {lines.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-white/60 hover:text-white transition-colors duration-300 text-sm" data-testid={`footer-line-${l.to.split('=')[1]}-link`}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <h4 className="font-display font-bold text-xs uppercase tracking-[0.2em] text-[#e05560] mb-6">{t('footer.contacts')}</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li>{t('contatti.hqValue')}</li>
              <li><a href="mailto:info@piattiprontiglutenfree.com" className="hover:text-white transition-colors duration-300" data-testid="footer-email-link">info@piattiprontiglutenfree.com</a></li>
              <li><a href="tel:+390425544695" className="hover:text-white transition-colors duration-300" data-testid="footer-phone-link">+39 0425 544695</a></li>
              <li className="text-white/40 font-display text-xs uppercase tracking-widest pt-2" data-testid="footer-certifications">ISO 9001 · Gluten Free</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Michelchef S.r.l. — PROPAQ. {t('footer.rights')}</span>
          <span className="font-display uppercase tracking-widest">{t('footer.made')}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
